
// material-ui
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { Box } from '@mui/material';
import TitleService from 'title-service';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { Button, Grid, Stack, Typography } from '@mui/material';
import AuthCardWrapper from 'views/pages/authentication/AuthCardWrapper';
import AuthFooter from 'ui-component/cards/AuthFooter';

export default function ViewSupportComponent(props: any) {
    // Generate Grid
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    function main(subcomponent: any): any {
        return (
            (() => {
                return (
                    <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
                        <Grid item xs={12}>
                            <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                                <Grid item sx={{ width: 440, position: 'relative' }}>
                                    {/* <CharacterCard /> */}
                                    <AuthCardWrapper>
                                        <Grid container spacing={2} alignItems="center" justifyContent="center">
                                            <Grid item sx={{ mb: 3 }}>

                                            </Grid>
                                            <Grid item xs={12}>
                                                <SupportScreenForm />
                                            </Grid>
                                        </Grid>
                                    </AuthCardWrapper>
                                    <img style={{
                                        position: 'absolute',
                                        'pointerEvents': 'none',
                                        zIndex: 0,
                                        top: -273,
                                        left: -275,
                                        opacity: .2
                                    }} src={`/login-images/PlaywatchICON.png`} />
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
                            <AuthFooter />
                        </Grid>
                    </Grid>
                )
            })()
        )
    }

    let output_main = main(null);


    return output_main

}

const SupportScreenForm = (props: { loginProp?: number }, { ...others }) => {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    const [showPassword, setShowPassword] = React.useState(false);

    return (
        <>
            <Grid container direction="column" justifyContent="center" spacing={2}>
                <Grid item xs={12}>
                    <Grid
                        container
                        direction={matchDownSM ? 'column-reverse' : 'row'}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Grid item>
                            <Stack alignItems="center" justifyContent="center" spacing={1}>
                                <Typography
                                    color={theme.palette.secondary.main}
                                    gutterBottom
                                    style={{ fontSize: '5em' }}
                                    variant={matchDownSM ? 'h2' : 'h2'}
                                >
                                    {TitleService('Need assistance?')}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <AnimateButton>
                        <Button
                            disableElevation
                            fullWidth
                            href='mailto:contact@playwatchkids.com?subject=HiPlaywatch'
                            size="large"
                            variant="outlined"
                            sx={{
                                color: 'grey.700',
                                backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                                borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.light + 20 : theme.palette.grey[100]
                            }}
                        >
                            <Box sx={{ mr: { xs: 1, sm: 2, width: 20 } }}>
                            </Box>
                            <h1>Contact Playwatch</h1>
                        </Button>
                    </AnimateButton>
                </Grid>
            </Grid>
        </>
    );
};
